// eslint-disable-next-line import/prefer-default-export
export const SET_SYSTEM_REPORT = 'system/set-system-report';
